import crmTable from './crmTable.vue'
import crmTableAppointment from './crmTableAppointment.vue'
import crmTableAccountOpening from './crmTableAccountOpening.vue'
import crmTableMotor from './crmTableMotor.vue'
import crmTableTM from './crmTableTM.vue'
import userTable from './userTable.vue'
import broadcastTable from './broadcastTable.vue'
import broadcastModal from './broadcastModal.vue'
import interactionsRightbar from './interactionsRightbar.vue'
import fallbackTable from './fallbackTable.vue'

export default {
  install(Vue) {
    Vue.component(crmTable.name, crmTable)
    Vue.component(fallbackTable.name, fallbackTable)
    Vue.component(crmTableAppointment.name, crmTableAppointment)
    Vue.component(crmTableAccountOpening.name, crmTableAccountOpening)
    Vue.component(crmTableMotor.name, crmTableMotor)
    Vue.component(crmTableTM.name, crmTableTM)
    Vue.component(userTable.name, userTable)
    Vue.component(broadcastTable.name, broadcastTable)
    Vue.component(broadcastModal.name, broadcastModal)
    Vue.component(interactionsRightbar.name, interactionsRightbar)
  },
}



// WEBPACK FOOTER //
// ./src/fragments/index.js